import { Button, useTheme } from '@ytl/common-web';
import { useLayoutEffect } from 'react';
import { ReactComponent as PageNotFoundIcon2 } from '../../../../assets/PageNotFound2.svg';
import { useLanguage } from '../../../../contexts/languageContext';

type BannedProps = {
  buttonAction?: () => void;
};

export const Banned = ({ buttonAction }: BannedProps) => {
  const { translation } = useLanguage();
  const { isWebView } = useTheme();

  useLayoutEffect(() => {
    document.documentElement.classList.add('banned-screen');
    return () => {
      document.documentElement.classList.remove('banned-screen');
    };
  }, []);

  return (
    <div className={`verification-step__banned${isWebView ? ' verification-step__banned--webview' : ''}`}>
      <div
        className={`verification-step__banned__illustration${isWebView ? ' verification-step__banned__illustration--webview' : ''}`}
      >
        <PageNotFoundIcon2 />
      </div>
      <div
        className={`verification-step__banned__content${isWebView ? ' verification-step__banned__content--webview' : ''}`}
      >
        <h2
          className={`verification-step__banned__header${isWebView ? ' verification-step__banned__header--webview' : ''}`}
          dangerouslySetInnerHTML={{ __html: translation.yeppRegistration.webcomponent.bannedHeader }}
        ></h2>
        <p
          className={`verification-step__banned__description${isWebView ? ' verification-step__banned__description--webview' : ''}`}
          dangerouslySetInnerHTML={{
            __html: translation.yeppRegistration.webcomponent.bannedText,
          }}
        />
        {!!buttonAction && (
          <div
            className={`verification-step__banned__actions${isWebView ? ' verification-step__banned__actions--webview' : ''}`}
          >
            <Button
              variant="contained"
              onClick={buttonAction}
            >
              {translation.onboarding.selectSubscriber.backToLoginApp}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
